let apiURL = document.querySelector("html").getAttribute("doctor_free_show");

if (process.env.NODE_ENV === "development") {
  // alert("开发环境");
  apiURL = 0
}

export default apiURL
